<template>
	<table class="table position-relative">
		<thead>
			<tr>
				<th scope="col">Number</th>
				<th scope="col">Usage Period</th>
				<th scope="col">Ammount</th>
				<th scope="col" class="text-right fixed-width">Status</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(invoice, i) in invoices" :key="i">
				<td>
					<router-link
						:to="{
							path: '/console/payment/details',
							query: { id: invoice.id },
						}"
					>
						{{ invoice.invoiceId }}
					</router-link>
				</td>
				<td>{{ billingPeriod[i] }}</td>
				<td>
					{{ getSymbol(invoice.currency) }} {{ invoice.amount / 100 }}
				</td>
				<td class="text-right">
					<button
						v-if="!invoice.paid"
						class="btn btn-primary"
						@click="payInvoice(invoice.id)"
					>
						<span
							v-if="loading[invoice.id]"
							class="spinner-border spinner-border-sm mr-2"
							role="status"
							aria-hidden="true"
						></span>
						Pay Now
					</button>
					<button v-else class="chips-secondary no-cursor">
						Paid
					</button>
				</td>
			</tr>
		</tbody>
		<ErrorDialog ref="errDialog" />
	</table>
</template>

<script>
import InvoiceService from '../../services/invoice';
import ErrorDialog from '../shared/ErrorDialog';
import dayjs from 'dayjs';
import { currencyMap } from '../../util/currency-symbol-map';

export default {
	name: 'InvoiceList',
	components: {
		ErrorDialog,
	},
	props: ['invoices'],
	data() {
		return {
			loading: {},
		};
	},
	methods: {
		payInvoice(invoiceId) {
			this.$set(this.loading, invoiceId, true);
			InvoiceService.instance()
				.payInvoice(invoiceId)
				.then(() => {
					this.loading[invoiceId] = false;
					this.$emit('invoicepaid');
				})
				.catch((err) => {
					this.loading[invoiceId] = false;
					this.$refs.errDialog.show(err);
				});
		},
		getSymbol(code) {
			let codeUpper = code.toUpperCase();
			return currencyMap[codeUpper];
		},
	},
	computed: {
		billingPeriod() {
			return this.invoices.map((inv) => {
				if (inv.period) {
					return (
						dayjs(inv.period.start).format('MMM DD') +
						' - ' +
						dayjs(inv.period.end).format('MMM DD')
					);
				} else {
					return 'n/a';
				}
			});
		},
	},
};
</script>

<style scoped>
.chips-secondary {
	background-color: #fff;
	font-size: 1.3rem;
	border-radius: 16px;
	border: 1px solid #212529;
	color: rgba(33, 37, 49, 0.87);
	padding: 0px 32px;
	margin: 8px 0;
}
.no-cursor:hover {
	cursor: default;
}
.fixed-width {
	width: 15rem;
}
</style>